import axios from 'axios';
import repository from "./repository";

const host = process.env.VUE_APP_HOST_URL;

let AuthorizationRepository = repository('/authorization');

AuthorizationRepository.login = (credentials) => {
    return axios.post(host + '/authenticate/login', credentials);
};

AuthorizationRepository.logout = () => {
    return axios.post(host + '/authenticate/logout');
};

AuthorizationRepository.blankSignInData = () => {
    return {
        email: '',
        password: ''
    }
};

AuthorizationRepository.validate = {
    email(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
};

export default AuthorizationRepository;
